import React, { useState } from 'react';
import Loading from '../../loading/loading.component';
import SingleCommentComponent from './single-comment-component';
import CommentInputComponent from './comment-input.component';
import _ from 'lodash';
import { useComment } from '../../../hooks/post/useComment';
import { useSelector } from 'react-redux';
import { RootState } from '../../../configuration';

interface CommentsComponentProps {
  post: any;
  userId: string;
  profileUser?: boolean;
  /** Số bình luận tải mỗi trang. Mặc định (không truyền) giữ hành vi cũ (feed). Reels truyền 10. */
  pageSize?: number;
}

export const CommentsComponent = ({
  post,
  userId,
  profileUser,
  pageSize,
}: CommentsComponentProps) => {
  const [pageNumberComment, setPageNumberComment] = useState<number>(1);
  const userProfile = useSelector(
    (state: RootState) => state.features.auth.profile
  );

  const {
    data: commentList,
    loading: loadingComment,
    hasMore: hasMoreComment,
    refreshCommentClient,
    updateComment,
    addComment,
    refreshCurrentPage,
    deleteComment,
    updateCommentLike,
  } = useComment({
    pageNumber: pageNumberComment,
    postId: _.get(post, 'id') || '',
    visible: true,
    pageSize,
  });

  return (
    <>
      {_.isEmpty(commentList) && !hasMoreComment ? null : (
        <div className="sm:p-4 p-2.5 border-t border-gray-100 font-normal space-y-3 relative dark:border-slate-700/40">
          {commentList.map((comment) => {
            return (
              <SingleCommentComponent
                key={comment.id}
                comment={comment}
                refreshCommentClient={refreshCommentClient}
                updateComment={updateComment}
                deleteComment={deleteComment}
                updateCommentLike={updateCommentLike}
                refreshCurrentPage={refreshCurrentPage}
                postOwnerId={_.get(post, 'userId')}
              />
            );
          })}
          {loadingComment ? <Loading /> : null}
          {hasMoreComment ? (
            <button
              className="text-sm text-slate-800 dark:text-slate-50 font-medium cursor-pointer"
              onClick={() => setPageNumberComment((prev: any) => prev + 1)}
            >
              Xem thêm
            </button>
          ) : null}
        </div>
      )}
      {!userProfile?.isBlockComment && profileUser && (
        <CommentInputComponent
          postId={post?.id}
          refreshCommentClient={refreshCommentClient}
          userId={userId}
          addComment={addComment}
          refreshCurrentPage={refreshCurrentPage}
        />
      )}
    </>
  );
};
